module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vbl-loading"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show) ? _c('div', [_c('div', {
    staticClass: "mask"
  }), _c('div', {
    staticClass: "vbl-loading-content"
  }, [_c('vbl-icon', {
    staticClass: "loading-rotate",
    attrs: {
      "type": "ion-load-c",
      "size": "50"
    }
  })], 1)]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06893e4a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblLoading/src/vblLoading.vue
// module id = 243
// module chunks = 0